<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData";
import axios from "axios";

export default {
    props: {
        value: [Number, Array, Object],
        multiple: Boolean,
        returnObject: Boolean,
        notClearable: Boolean,
        selectMax: Boolean,
        label: String,
        readonly: Boolean,
        rules: Array,
        type: String,
        cycle: String,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const performance = ref(null);
        const performances = ref([]);

        function findAll() {
            loading.value = true;
            axios.get('/evaluationPerformances', {
                params: {
                    sortBy: "postDateTime",
                    descending: true,
                    allRecords: true,
                }
            }).then(response => {
                performances.value = response.data.elements;
                if(performances.value.length > 0 && props.selectMax)
                    emit('input', performances.value[0].id);
            }).finally(() => {
                loading.value = false;
            })
        }

        watch(() => props.value, () => {
            performance.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            performance,
            performances,
            loading,
            inputColor,
            backgroundColor
        }
    }
};
</script>

<template>
    <div>
        <v-autocomplete
            v-model="performance"
            :label="label"
            :items="performances"
            item-value="id"
            item-text="name"
            outlined
            dense
            :return-object="returnObject"
            :loading="loading"
            :readonly="readonly"
            :multiple="multiple"
            :chips="multiple"
            :deletable-chips="multiple"
            :clearable="!(readonly || notClearable)"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="$emit('input', performance)"
            :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>